import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import CardLayout from '../../../components/utils/CardLayout'
import Table from '../../../components/utils/Table'
import { useDispatch, useSelector } from 'react-redux';
import ActivationRequest from './ActivationRequest';
import DailyPlanRequest from './DailyPlanRequest'
import SIMSWapRequest from './SimSwapRequest'


const LockedActivation = () => {
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState('Activation Request');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    const activationRequestPage = () => {
        return <ActivationRequest />;
    }
    const dailyPlanRequestPage = () => {
        return <DailyPlanRequest />;
    }

    const simSwapRequestPage = () => {
        return <SIMSWapRequest />;
    }

    return (
        <CardLayout title={activeTab}>
            <>
                <ul className="nav nav-tabs plan-tab" id="myTab" role="tablist" style={{ display: 'flex', gap: '2px' }}>
                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'Activation Request' ? 'active' : ''}`} onClick={() => handleTabClick('Activation Request')} >
                            Activation Request
                        </button>
                    </li>

                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'Daily Plan Request' ? 'active' : ''}`} onClick={() => handleTabClick('Daily Plan Request')} >
                            Daily Plan Request
                        </button>
                    </li>

                    <li className="nav-item" role="presentation">
                        <button className={`nav-link ${activeTab === 'SIM Swap Request' ? 'active' : ''}`} onClick={() => handleTabClick('SIM Swap Request')} >
                            SIM Swap Request
                        </button>
                    </li>

                </ul>

                {activeTab == 'Activation Request' ? activationRequestPage() : ''}
                {activeTab == 'Daily Plan Request' ? dailyPlanRequestPage() : ''}
                {activeTab == 'SIM Swap Request' ? simSwapRequestPage() : ''}
            </>
        </CardLayout>
    )
}

export default LockedActivation
